import { FinancialReportComponent } from "./financial-report/financial-report.component";
import { ReminderFormComponent } from "./reminder/reminder-form/reminder-form.component";
import { MarketingDashboardComponent } from "./dashboard/marketing-dashboard/marketing-dashboard.component";
import { ImageZoomService } from "./shared/image-zoom/image-zoom.service";
import { ImageZoomComponent } from "./shared/image-zoom/image-zoom.component";
import { EditCustomerDialogComponent } from "./dialogs/edit-customer-dialog/edit-customer-dialog.component";
import { AddCustomerDialogComponent } from "./dialogs/add-customer-dialog/add-customer-dialog.component";
import { EditEoiCustomerDialogComponent } from "./eois/dialogs/edit-eoi-customer-dialog.component";
import { HelpdeskDashboardComponent } from "./dashboard/helpdesk-dashboard/helpdesk-dashboard.component";
import { AccountantDashboardComponent } from "./dashboard/accountant-dashboard/accountant-dashboard.component";
import { HelpdeskService } from "./services/helpdesk/helpdesk.service";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
// import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatDatepickerModule,
  MatFormFieldModule,
  MatInputModule,
  MatNativeDateModule,
  MatButtonModule,
  MatTooltipModule,
  MatCardModule,
  MatSlideToggleModule,
  MatAutocompleteModule,
  MatMenuModule,
  MatIconModule,
  MatTabsModule,
  MatChipsModule,
  MatDialogModule,
} from "@angular/material";

import { NgxPaginationModule } from "ngx-pagination";
import { CookieService } from "ngx-cookie-service";
import { DropdownModule } from "ngx-dropdown";
import { ChartsModule } from "ng2-charts";
import { SlimLoadingBarModule } from "ng2-slim-loading-bar";
import { SweetAlert2Module } from "@toverux/ngx-sweetalert2";
import { ModalModule } from "ngx-modal";
import { MomentModule } from "angular2-moment/moment.module";
import { NguiAutoCompleteModule } from "@ngui/auto-complete";
import { Ng2AutoCompleteModule } from "ng2-auto-complete";
import { MultiSelectModule } from "primeng/multiselect";
import { ProgressBarModule } from "primeng/progressbar";
import { CalendarModule } from "primeng/calendar";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { ToggleButtonModule } from "primeng/togglebutton";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NouisliderModule } from "ng2-nouislider";
import { NgxToggleModule } from "ngx-toggle";
import { CountdownTimerModule } from "ngx-countdown-timer";
import { ModalGalleryModule } from "angular-modal-gallery";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AutoCompleteModule } from "ng5-auto-complete";
import { ScrollToModule } from "ng2-scroll-to-el";
import { Ng2PageScrollModule } from "ng2-page-scroll";
import { NgxAutoScrollModule } from "ngx-auto-scroll";
import { CurrencyMaskModule } from "ng2-currency-mask";

import "hammerjs";
import "mousetrap";

import { WalletGuard } from "./guards/wallet.guard";
import { TargetsGuard } from "./guards/targets.guard";
import { MarketingService } from "./services/marketing/marketing.service";
import { NotificationsService } from "./services/notifications/notifications.service";
// import { ChatService } from "./services/chat/chat.service";
import { FinanceService } from "./services/finance/finance.service";
import { TeamService } from "./services/settings-service/team/team.service";
import { BranchService } from "./services/branch/branch.service";
import { UserProfileService } from "./services/event-bus/user-profile.service";
import { SettingTabGuard } from "./guards/settingsTab.guard";
import { AddLeadGuard } from "./guards/addLead.guard";
import { LoginGuard } from "./guards/login.guard";
import { PaymentGeneratorGuard } from "./guards/paymentGenerator.guard";
import { ReservationsGuard } from "./guards/reservations.guard";
import { EoisGuard } from "./guards/eois.guard";
import { LeadsGuard } from "./guards/leads.guard";
import { BlockRequestListGuard } from "./guards/blockRequestList.guard";
import { AddProjectGuard } from "./guards/addProject.guard";
import { ReservationHelperService } from "./services/reservation-helper/reservation-helper.service";
import { PaymentService } from "./services/payment/payment.service";
import { KeysPipe } from "./pipes/keys.pipe";
import { ErrorHandlerService } from "./services/shared/error-handler.service";
import { ReservationService } from "./services/reservation-service/reservation.service";
import { BlockRequestsListComponent } from "./block-requests-list/block-requests-list.component";
import { DropdownModule as primeDropdown } from "primeng/dropdown";
import { ReservationComponent } from "./reservation/reservation.component";
import { AddreservationComponent } from "./reservation/addreservation/addreservation.component";
import { EoiService } from "./services/eoi/eoi.service";
import { ProjectsService } from "./services/projects/projects.service";
import { LeadsService } from "./services/lead-service/lead-service.service";
import { AuthInterceptor } from "./guards/auth-interceptor";
import { AuthGuard } from "./guards/authguard.guard";
import { ProjectsComponent } from "./projects/projects.component";
import { UserServiceService } from "./services/user-service/user-service.service";
import { LoginComponent } from "./login/login.component";
import { MainComponent } from "./main/main.component";
import { AppComponent } from "./app.component";
import { NavModule } from "./layout/navbar/navbar.module";
import { HeaderModule } from "./layout/header/header.module";
import { LeadsModule } from "./lead/dashboard/lead.module";
import { BreadcrumbModule } from "./layout/breadcrumb/breadcrumb.module";
import { AppRoutingModule } from "./app-routing.module";
// import {AddLeadModule} from './lead/addlead/addlead.module'
import { AddLeadModule } from "./lead/addLead/addlead.module";
import { MockApi } from "././dtos/mockapi";
import { AdminDashboardComponent } from "./dashboard/admin-dashboard/admin-dashboard.component";
import { ImportUnitsComponent } from "./import-units/import-units.component";

import { AddProjectComponent } from "./add-project/add-project.component";
import { UnitsComponent } from "./units/units.component";
import { PaymentGeneratorComponent } from "./payment-generator/payment-generator.component";
import { HashwordsProvider } from "./services/libs.providers";
import { ContractGenerateComponent } from "./contract-generate/contract-generate.component";
import { UnitViewComponent } from "./unit-view/unit-view.component";
import { LayoutComponent } from "./layout/layout.component";
import { UploadLayoutComponent } from "./upload-layout/upload-layout.component";
import { ReservationViewComponent } from "./reservation-view/reservation-view.component";
import { CanEnterProjectsTab } from "./guards/projects.guard";
import { ProfileComponent } from "./profile/profile.component";
import { FinanceAccountsComponent } from "./finance-accounts/finance-accounts.component";
import { FinanceAddAccountComponent } from "./finance-add-account/finance-add-account.component";
import { FinanceBalanceSheetComponent } from "./finance-balance-sheet/finance-balance-sheet.component";
import { FinanceTransactionComponent } from "./finance-transaction/finance-transaction.component";
import { FinanceAddTransactionComponent } from "./finance-add-transaction/finance-add-transaction.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { MarketingComponent } from "./marketing/marketing.component";
import { ReportsComponent } from "./reports/reports.component";
import { CliComponent } from "./cli/cli.component";
import { CilService } from "./cil.service";

import { AvailabilityRequestComponent } from "./availability-request/availability-request.component";
import { PriceControlComponent } from "./price-control/price-control.component";
import { PriceControllerRequestsComponent } from "./price-controller-requests/price-controller-requests.component";
import { MasterPlanComponent } from "./master-plan/master-plan.component";
import { AllUnitViewComponent } from "./all-unit-view/all-unit-view.component";
import { WalletComponent } from "./reports/wallet/wallet.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { CeoDashboardComponent } from './dashboard/ceo-dashboard/ceo-dashboard.component';
import { UserDashboardComponent } from "./dashboard/user-dashboard/user-dashboard.component";
import { AccountsService } from "./services/settings-service/accounts/accounts.service";

import { NgxImageZoomModule } from "ngx-image-zoom";

// import { GalleryModule } from 'ng-gallery';

// import { NgxImageGalleryModule } from 'ngx-image-gallery';

import { DndListModule } from "ngx-drag-and-drop-lists";
import { LightboxModule } from "ngx-lightbox";
import { AnnouncementComponent } from "./announcement/announcement.component";

// import { UiSwitchModule } from 'ngx-toggle-switch';

import { NgxDropzoneModule } from "ngx-dropzone";
// import {IvyCarouselModule} from 'angular-responsive-carousel';

import { RotationComponent } from "./rotation/rotation.component";
import { CampaignsComponent } from "./campaigns/campaigns.component";
import { RotationLogsComponent } from "./rotation-logs/rotation-logs.component";
import { LogsComponent } from "./logs/logs.component";
import { OnlyNumbersDirective } from "./directives/only-numbers.directive";
import { MarketingReportsComponent } from "./marketing-reports/marketing-reports.component";
import { ColdCallsListingComponent } from "./cold-calls-listing/cold-calls-listing.component";
import { ColdCallsFilesComponent } from "./cold-calls-files/cold-calls-files.component";
import { ReminderComponent } from "./reminder/reminder.component";
import { ReminderService } from "./services/reminder/reminder.service";
import { HttpModule } from "@angular/http";
import { UpcomingSceneComponent } from "./upcoming-scene/upcoming-scene.component";

import { PinchZoomModule } from "ngx-pinch-zoom";
import { PaymentCollectionsComponent } from "./payment-collections/payment-collections.component";
import { DuplicatedLeadsComponent } from "./duplicated-leads/duplicated-leads.component";

import { NgxPrintModule } from "ngx-print";
import { TrashLeadsComponent } from "./trash-leads/trash-leads.component";
import { DailyReportComponent } from "./daily-report/daily-report.component";

import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";

import { NgSelectModule } from "@ng-select/ng-select";
import { AddRotationComponent } from "./add-rotation/add-rotation.component";
import { RotationsListComponent } from "./rotations-list/rotations-list.component";
import { PrintChequeComponent } from "./print-cheque/print-cheque.component";
import { ListingLeadsByActivitesComponent } from "./listing-leads-by-activites/listing-leads-by-activites.component";
import { BankChequeListingComponent } from "./bank-cheque-listing/bank-cheque-listing.component";
import { MailBuilderComponent } from "./mail-builder/mail-builder.component";
import { ColdCallsSheetsComponent } from "./cold-calls-sheets/cold-calls-sheets.component";
import { AddTicketComponent } from "./add-ticket/add-ticket.component";
import { TicketsComponent } from "./tickets/tickets.component";
import { TicketViewComponent } from "./ticket-view/ticket-view.component";
import { AssignTicketModalComponent } from "./ticket-view/modals/assign-ticket-modal/assign-ticket-modal.component";
import { AddFeedbackModalComponent } from "./ticket-view/modals/add-feedback-modal/add-feedback-modal.component";
import { RequestApprovalModalComponent } from "./ticket-view/modals/request-approval-modal/request-approval-modal.component";
import { ChangeStatusModalComponent } from "./ticket-view/modals/change-status-modal/change-status-modal.component";
import { ResolveApprovalRequestModalComponent } from "./ticket-view/modals/resolve-approval-request-modal/resolve-approval-request-modal.component";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { SearchTicketComponent } from "./ticket-view/modals/search-ticket/search-ticket.component";
import { RolesService } from "./main-settings/roles/roles.service";
import { PermissionsService } from "./services/permissions/permissions.service";
import { MatExpansionModule } from "@angular/material/expansion";
import { AddEoiComponent } from "./eois/add-eoi/add-eoi.component";
import { EoiComponent } from "./eois/eoi/eoi.component";
import { EoiTableComponent } from "./eois/eoi-table/eoi-table.component";
import { HelperService } from "./services/shared/helper.service";
import { EoiViewComponent } from "./eois/eoi-view/eoi-view.component";
import { HoldListComponent } from "./hold-module/hold-list/hold-list.component";
import { AddHoldComponent } from "./hold-module/add-hold/add-hold.component";
import { HoldDetailsComponent } from "./hold-module/hold-details/hold-details.component";
import { HoldService } from "./hold-module/hold.service";
import { ColumnsFilterComponent } from "./shared/columns-filter/columns-filter.component";
import { KeyValuePipe } from "./shared/keyValue.pipe";
import { GlobalNotificationsService } from "./services/global-notifications/global-notifications.service";
import { environment } from "../environments/environment.prod";
import { SidebarModule } from "primeng/sidebar";

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FinancialReportsService } from "./services/financial-reports/financial-reports.service";
import { CustomersBirthdayComponent } from "./customers-birthday/customers-birthday.component";
import { TimerComponent } from "./shared/components/timer.component";
import { ClientStatementsComponent } from "./client-statements/client-statements.component";
import { ViewClientStatementsComponent } from "./view-client-statements/view-client-statements.component";
import { PaymentCollectionViewComponent } from "./payment-collection-view/payment-collection-view.component";
import { FinesListComponent } from "./fines-list/fines-list.component";
import { BrokersListComponent } from "./brokers-list/brokers-list.component";
import { BuildComponent } from "./build/build.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { ErpLogsComponent } from "./erp-logs/erp-logs.component";
import { BrokersIncentivesComponent } from "./brokers-incentives/brokers-incentives.component";
import { BrokersIncentivesManageComponent } from "./brokers-incentives-manage/brokers-incentives-manage.component";
import { BrokerWalletComponent } from "./broker-wallet/broker-wallet.component";
import { MarketingReportComponent } from "./marketing-report/marketing-report.component";
import { InventoryReportComponent } from "./inventory-report/inventory-report.component";
import { CommonModule } from "@angular/common";
import { AllPagesComponent } from "./all-pages/all-pages.component";
import { CashFlowReportComponent } from "./cash-flow-report/cash-flow-report.component";
import { CeoReportsComponent } from './ceo-reports/ceo-reports.component';
import { CeoReportsService } from "./services/ceo-reports/ceo-reports.service";

import { UploadProjectOfferImagesComponent } from "./upload-project-offer-images/upload-project-offer-images.component";
import { LayoutDialogComponent } from './layout-dialog/layout-dialog.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from "@tinymce/tinymce-angular";
import { JsonEditorModalComponent } from './json-editor-modal/json-editor-modal.component';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { InvalidLeadsComponent } from "./invalid-leads/invalid-leads.component";
import { BrokersComponent } from "./main-settings/brokers/brokers.component";
import { AddBrokerComponent } from "./main-settings/brokers/add-broker/add-broker.component";
import { SettingService } from "./services/settings-service/setting.service";
import { TodosComponent } from "./todos/todos.component";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/");
}

declare const firebase: any;

firebase.initializeApp(environment.firebase);

@NgModule({
  declarations: [
    AppComponent,
    KeyValuePipe,
    ColumnsFilterComponent,
    LoginComponent,
    MainComponent,
    ProjectsComponent,
    AdminDashboardComponent,
    CeoDashboardComponent,
    MarketingDashboardComponent,
    EoiComponent,
    EoiTableComponent,
    AddEoiComponent,
    EoiViewComponent,
    ImportUnitsComponent,
    AddreservationComponent,
    ReservationComponent,
    AddProjectComponent,
    UnitsComponent,
    BlockRequestsListComponent,
    PaymentGeneratorComponent,
    KeysPipe,
    ContractGenerateComponent,
    UnitViewComponent,
    LayoutComponent,
    UploadLayoutComponent,
    ReservationViewComponent,
    ProfileComponent,
    FinanceAccountsComponent,
    FinanceAddAccountComponent,
    FinanceBalanceSheetComponent,
    FinanceTransactionComponent,
    FinanceAddTransactionComponent,
    NotificationsComponent,
    MarketingComponent,
    ReportsComponent,
    CliComponent,
    AvailabilityRequestComponent,
    PriceControlComponent,
    PriceControllerRequestsComponent,
    MasterPlanComponent,
    AllUnitViewComponent,
    WalletComponent,
    DashboardComponent,
    UserDashboardComponent,
    AccountantDashboardComponent,
    HelpdeskDashboardComponent,
    AnnouncementComponent,
    RotationComponent,
    CampaignsComponent,
    RotationLogsComponent,
    LogsComponent,
    MarketingReportsComponent,
    ColdCallsListingComponent,
    ColdCallsFilesComponent,
    ReminderComponent,
    ReminderFormComponent,
    UpcomingSceneComponent,
    PaymentCollectionsComponent,
    DuplicatedLeadsComponent,
    TrashLeadsComponent,
    DailyReportComponent,
    AddRotationComponent,
    RotationsListComponent,
    PrintChequeComponent,
    ListingLeadsByActivitesComponent,
    BankChequeListingComponent,
    MailBuilderComponent,
    ColdCallsSheetsComponent,
    AddTicketComponent,
    TicketsComponent,
    TicketViewComponent,
    AssignTicketModalComponent,
    AddFeedbackModalComponent,
    RequestApprovalModalComponent,
    ChangeStatusModalComponent,
    ResolveApprovalRequestModalComponent,
    SearchTicketComponent,
    HoldListComponent,
    AddHoldComponent,
    HoldDetailsComponent,
    ImageZoomComponent,
    FinancialReportComponent,
    CustomersBirthdayComponent,
    TimerComponent,
    ClientStatementsComponent,
    ViewClientStatementsComponent,
    PaymentCollectionViewComponent,
    FinesListComponent,
    BrokersListComponent,
    BrokersComponent,
    AddBrokerComponent,
    BuildComponent,
    ErpLogsComponent,
    BrokersIncentivesComponent,
    BrokersIncentivesManageComponent,
    BrokerWalletComponent,
    MarketingReportComponent,
    InventoryReportComponent,
    AllPagesComponent,
    CashFlowReportComponent,
    CeoReportsComponent,
    UploadProjectOfferImagesComponent,
    LayoutDialogComponent,
    JsonEditorModalComponent,
    InvalidLeadsComponent,
    EditCustomerDialogComponent,
    AddCustomerDialogComponent,
    EditEoiCustomerDialogComponent,
    TodosComponent,
  ],
  entryComponents: [LayoutDialogComponent, EditCustomerDialogComponent, AddCustomerDialogComponent, EditEoiCustomerDialogComponent],
  imports: [
    BrowserModule,
    FormsModule,
    DndListModule,
    ReactiveFormsModule,
    NgxImageZoomModule,
    NgxToggleModule,
    DropdownModule,
    NavModule,
    HeaderModule,
    LeadsModule,
    BreadcrumbModule,
    AppRoutingModule,
    AddLeadModule,
    ModalModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    ChartsModule,
    SlimLoadingBarModule.forRoot(),
    SweetAlert2Module.forRoot(),
    ModalGalleryModule.forRoot(),
    MomentModule,
    NguiAutoCompleteModule,
    Ng2AutoCompleteModule,
    CountdownTimerModule.forRoot(),
    CalendarModule,
    NgbModule.forRoot(),
    primeDropdown,
    AutoCompleteModule,
    MultiSelectModule,
    AutoCompleteModule,
    ProgressBarModule,
    AngularMultiSelectModule,
    ToggleButtonModule,
    ScrollToModule.forRoot(),
    Ng2PageScrollModule,
    NgxAutoScrollModule,
    InfiniteScrollModule,
    NouisliderModule,
    CurrencyMaskModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatCardModule,
    MatTooltipModule,
    MatMenuModule,
    MatTabsModule,
    MatChipsModule,
    NgxImageZoomModule.forRoot(),
    LightboxModule,
    HttpModule,
    NgxDropzoneModule,
    PinchZoomModule,
    NgxPrintModule,
    NgMultiSelectDropDownModule,
    NgSelectModule,
    NgxUiLoaderModule,
    MatExpansionModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SidebarModule,
    MatProgressBarModule,
    MatIconModule,
    HeaderModule,
    EditorModule,
    // ColumnsFilterModule,
    Ng2TelInputModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    MockApi,
    UserServiceService,
    CookieService,
    AuthGuard,
    LeadsService,
    RolesService,
    PermissionsService,
    ProjectsService,
    EoiService,
    ReservationService,
    ErrorHandlerService,
    HashwordsProvider,
    PaymentService,
    { provide: "Hashwords", useValue: window["hashwords"]() },
    CanEnterProjectsTab,
    AddProjectGuard,
    BlockRequestListGuard,
    LeadsGuard,
    EoisGuard,
    ReservationsGuard,
    PaymentGeneratorGuard,
    LoginGuard,
    AddLeadGuard,
    SettingTabGuard,
    TargetsGuard,
    UserProfileService,
    BranchService,
    TeamService,
    AccountsService,
    FinanceService,
    GlobalNotificationsService,
    NotificationsService,
    SettingService,
    MarketingService,
    CilService,
    ReminderService,
    HelpdeskService,
    { provide: "Hashwords", useValue: window["hashwords"]() },
    WalletGuard,
    HelperService,
    HoldService,
    ImageZoomService,
    FinancialReportsService,
    CeoReportsService,
    { provide: TINYMCE_SCRIPT_SRC, useValue: "tinymce/tinymce.js" },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts